import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var CarIcon =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsx("svg", {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14 7-.4-2-.44-2.196A1 1 0 0 0 12.18 2H3.82a1 1 0 0 0-.98.804L2.4 5 2 7 1 8.2V12a1 1 0 0 0 1 1v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V13h6v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V13a1 1 0 0 0 1-1V8.2L14 7Zm-2.444-2h.004l-.2-1H4.64l-.2 1h.004L4 7h8l-.444-2ZM3 10.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "currentColor"
  })
});